import { LookupEdit } from '@powerportalspro/react-fluent';

export function LookupEditMainSample() {
  return <LookupEdit columnName="ppp_parentcustomerid" style={{ maxWidth: 300 }} />;
}
